import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ClipboardService } from 'node_modules/ngx-clipboard';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Location } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  searchText: string = '';
  type: string = '';
  loggedIn =  false;
  formClicked =  false;
  data:any = [];
  item:any = {};
  itemType:any = {};
  message = '';
  error = '';
  redirectTo = '';
  Location = null;
  constructor(public cs: CommonService, private location: Location, public http: HttpClient
    , public dialog: MatDialog, private router: Router, private _snackBar: MatSnackBar
    , private route: ActivatedRoute, private _clipboardService: ClipboardService) {
    if (this.cs.user.access_token) {
      this.loggedIn = true;
    }
  }

  ngOnInit() {
    this.redirectTo = this.cs.redirectTo;
    this.cs.redirectTo = '';
    this.route.paramMap.subscribe((params: any) => {
      this.searchText = '';
      if(params != null && params.params != null && params.params.type != null){
        this.type= params.params.type.toLowerCase();
      }
      if(params != null && params.params != null && params.params.keyword != null){
        this.searchText= params.params.keyword.toLowerCase();
      }
      this.searchData();
    });
  }

    handleCurrentLocationAddressChange(event) {
    var street_number = '';
    var route = '';

    this.Location = {};

    for (let address of event.address_components) {
      if (address.types.indexOf("locality") != -1) {
        this.Location.City = address.short_name
      } else if (address.types.indexOf("route") != -1) {
        route = address.short_name;
      } else if (address.types.indexOf("street_number") != -1) {
        street_number = address.short_name;
      }else if (address.types.indexOf("administrative_area_level_1") != -1) {
        this.Location.State = address.short_name;
      }else if (address.types.indexOf("administrative_area_level_2") != -1) {
        this.Location.County = address.short_name;
      } else if (address.types.indexOf('postal_code') != -1) {
        this.Location.Zip = address.long_name;
      } else if (address.types.indexOf('country') != -1) {
        this.Location.Country = address.short_name;
      }
    }
    if(this.Location.Country == null || this.Location.Country == undefined || this.Location.Country == '') {
      this.Location.City = '';
      return;
    }

    this.Location.Lat = event.geometry.location.lat();
    this.Location.Lng = event.geometry.location.lng();

    if(street_number != null && street_number.length > 0){
      this.Location.Street = street_number;
    }
    if(route != null && route.length > 0){
      if(this.Location.Street != null &&  this.Location.Street.length > 0){
        this.Location.Street += ' ';
      }
      if(this.Location.Street){
        this.Location.Street += route;
      }
    }

    this.Location.Error = '';
  }

  showDetails(item){
    this.clearMessageAndError();
    this.itemType = this.cs.enumTable.SearchType[item.Type];
    this.cs.request('/public/' + (this.cs.enumTable.SearchType[item.Type].Value).toLowerCase() + '?id=' + item.InternalId, 'get').then((res: any) => {
      if (res.Status == 200) {
        this.item = res.Data;
        this.item.DescriptionFormatted = this.item.Description.replace(/\n/g, '<br/>')
        this.item.Pictures = this.item.Picture.split(',');
        if(this.item.Pictures && this.item.Pictures.length == 0){
          this.item.Pictures.push(this.item.Picture.trim());
        }else {
          this.item.Picture = this.item.Pictures[0];
        }

        if(this.redirectTo != null && this.redirectTo == 'search/event/' + this.data[0].InternalId ){
          //Auto rsvp
          this.update();
        }
      } else {
        this.error = res.Message;
      }
      this.redirectTo = '';
    }).catch((err) => {
      this.redirectTo = '';
    });
  }

  isValidRsvp(value: any): boolean {
    if (value == null) return false;
    const num = Number(value);
    return (!isNaN(num) && num >= 1 && num <= 8);
  }

  isValidName(value: any): boolean {
    if (!value) return false;

    const parts = String(value).trim().split(' ');
    return parts.length >= 2;
  }

  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  validatePhone(phone: string): boolean {
    const phoneRegex = /^(1)?(\d{10}|\(\d{3}\)\s?\d{3}[\s-]?\d{4}|\d{3}[\s-]?\d{3}[\s-]?\d{4})$/;
    return phoneRegex.test(phone);
  }

  update(){
    this.clearMessageAndError();
    this.formClicked = true;

    this.error = '';

    /*
    if(this.Location == null || this.Location.Street == null || this.Location.City == null || this.Location.State == null  || this.Location.Zip == null || this.Location.Country == null
       || this.Location.Street == '' || this.Location.City == '' || this.Location.State == ''  || this.Location.Zip == '' || this.Location.Country == ''
    ){
      this.Location = {};
      return;
    }
  */
    if(this.itemType.Value.toLowerCase() == 'event' && 
      (!this.item.Email || this.item.Email.trim() == '' 
      || !this.item.Phone || this.item.Phone.trim() == ''
      || !this.item.FullName || this.item.FullName.trim() == ''
      || !this.item.RsvpCount || this.item.RsvpCount.trim() == ''
      || !this.item.FullName || this.item.FullName.trim() == ''
    )){
      return;
    }

    //this.item.Location = this.Location;
    this.cs.request('/public/' + this.itemType.Value.toLowerCase(), 'post', this.item).then((res: any) => {
      if (res.Status == 200) {
        this.message = res.Message;
      } else {
        this.error = res.Message;
      }
    }).catch((err) => {
    });

  }

  clearData(){
    this.item = {};
    this.itemType = {};
    this.data = [];
  }

  share(item){
    var url = 'https://event.rishiyog.org/api/public/detail/' + this.itemType.Value.toLowerCase() + '/' + item.Id;

    this._clipboardService.copy(url);
    this._snackBar.open("Copied to Clipboard", "", {
      duration: 2000,
    });
  }

  search(){
    this.type = '';
    this.searchData();
  }

  searchData(){
    this.clearData();
    this.clearMessageAndError();
    var param = '';
    if(this.searchText != null && this.searchText != ''){
      param = 'keyword=' + this.searchText;
    }
    if(this.type != null && this.type != ''){
      if(param != null && param != ''){
        param = param + '&';
      }
      param = param + 'type=' + this.type;
    }
    this.cs.request('/public/search?' + param, 'get').then((res: any) => {
      if (res.Status == 200) {
        this.data = res.Data;
        if(this.type != null && this.type != '' && (this.type == 'event' || this.type == 'blog') && this.data != null && this.data.length == 1){
          this.showDetails(this.data[0]);
        }
      } else {
        this.error = res.Message;
      }
    }).catch((err) => {
    });
  }

  clearMessageAndError(){
    this.error = '';
    this.message = '';
  }
}
